import { api } from "@/lib/api-client";
import type { Pagination } from "@/types/time";

export interface Member {
  id: string;
  userId: string;
  role: string;
  user: {
    name: string;
    email: string;
    image: string | null;
  };
}

export async function getMe() {
  return api<Member>("/api/me");
}

export async function getMembers(params?: {
  search?: string;
  page?: number;
  perPage?: number;
}) {
  const query = new URLSearchParams();
  if (params?.search) query.set("search", params.search);
  if (params?.page) query.set("page", String(params.page));
  if (params?.perPage) query.set("per_page", String(params.perPage));
  const qs = query.toString();
  return api<{ data: Member[]; pagination: Pagination }>(
    `/api/members${qs ? `?${qs}` : ""}`
  );
}
